export default __webpack_public_path__ + "static/media/box-6Closed.d053f866.jpg";